import { render, staticRenderFns } from "./tabBelnizView.vue?vue&type=template&id=b52cf9a2&scoped=true"
import script from "./tabBelnizView.vue?vue&type=script&lang=js"
export * from "./tabBelnizView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52cf9a2",
  null
  
)

export default component.exports